// import React, { useState, useEffect } from "react";
// import s from "./language.module.css";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";
// import Custombutton from "../../Common/Custombutton";
// import { notificationHandler } from "../../utils/Notification";
// import { useLocation } from "react-router-dom";
// import { Card, Grid } from "@mui/material";
// import RichTextEditor from "react-rte-17";
// import { get_all_tag_list, get_all_tag_list_dropdown } from "../api/tag";
// import MultipleSelect from "./MultipleSelect";
// import {
//   addLanguage_api,
//   getLanguages_api,
//   getLibraryMediaById_api,
//   updateLanguage_api,
// } from "../api/librarymedia";
// import Loder from "../../Loder/Loder";

// const EditLibraryMedia = (props) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [titleEnglish, settitleEnglish] = useState("");
//   const [titleHindi, settitleHindi] = useState("");
//   const [descEnglish, setdescEnglish] = useState("");
//   const [descHindi, setdescHindi] = useState("");
//   const [url, seturl] = useState("");
//   const [thumbnail, setthumbnail] = useState("");
//   const [editor, seteditor] = useState(RichTextEditor.createEmptyValue());
//   const [editor2, seteditor2] = useState(RichTextEditor.createEmptyValue());
//   const [tags, settags] = useState([]);
//   const [allTag, setallTag] = useState([]);
//   const pagetype = location?.state?.pagetype;
//   const [libraryMedia, setlibraryMedia] = useState("");
//   const [isLoading, setisLoading] = useState(false);

//   useEffect(() => {
//     fetchallLibraryMediaFunc();
//   }, []);
//   const fetchallLibraryMediaFunc = async () => {
//     setisLoading(true);
//     try {
//       let res = await getLibraryMediaById_api(location?.state?.data._id);
//       const { libraryMedia } = res?.data?.data;
//       if (res.data.status) {
//         setlibraryMedia(libraryMedia);
//         setthumbnail(libraryMedia?.thumbnail?.url);
//         settitleEnglish(libraryMedia?.titleEnglish);
//         settitleHindi(libraryMedia?.titleHindi);
//         seturl(libraryMedia?.url);
//         setdescHindi(libraryMedia?.descHindi);
//         setdescEnglish(libraryMedia?.descEnglish);
//         const initialEditorState = RichTextEditor.createValueFromString(
//           libraryMedia?.lyrics?.hindi,
//           "html"
//         );
//         seteditor(initialEditorState);
//         const initialEditorState2 = RichTextEditor.createValueFromString(
//           libraryMedia?.lyrics?.english,
//           "html"
//         );
//         seteditor2(initialEditorState2);
//         setisLoading(false);
//       } else {
//         console.log("status false!");
//         setisLoading(false);
//       }
//     } catch (error) {
//       console.log(error);
//       setisLoading(false);
//     }
//   };

//   const onChange1 = (value) => {
//     seteditor(value);
//     if (props.onChange) {
//       props.onChange(value.toString("html"));
//     }
//   };
//   const onChange2 = (value) => {
//     seteditor2(value);
//     if (props.onChange) {
//       props.onChange(value.toString("html"));
//     }
//   };

//   const create_user = async () => {
//     if (pagetype == "Add") {
//       const fd = new FormData();
//       fd.append("titleEnglish", titleEnglish);
//       fd.append("titleHindi", titleHindi);
//       fd.append("descEnglish", descEnglish);
//       fd.append("descHindi", descHindi);
//       fd.append("url", url);
//       fd.append("mediaType", "audio");
//       fd.append(
//         "lyrics",
//         JSON.stringify({
//           hindi: editor.toString("html"),
//           english: editor2.toString("html"),
//         })
//       );
//       fd.append("tags", tags);
//       fd.append("thumbnail", thumbnail);

//       try {
//         let res = await addLanguage_api(fd);
//         if (res.data.status) {
//           navigate("/library-media");
//           notificationHandler({ type: "success", msg: res.data.message });
//         } else {
//           notificationHandler({ type: "success", msg: res.data.message });
//         }
//       } catch (error) {
//         notificationHandler({ type: "danger", msg: error.message });
//         console.log(error);
//       }
//     }
//     if (pagetype == "Edit") {
//       const fd = new FormData();
//       fd.append("titleEnglish", titleEnglish);
//       fd.append("titleHindi", titleHindi);
//       fd.append("descEnglish", descEnglish);
//       fd.append("descHindi", descHindi);
//       fd.append("url", url);
//       fd.append("mediaType", "audio");
//       fd.append(
//         "lyrics",
//         JSON.stringify({
//           hindi: editor.toString("html"),
//           english: editor2.toString("html"),
//         })
//       );
//       fd.append("tags", tags);
//       fd.append("thumbnail", thumbnail);
//       try {
//         let res = await updateLanguage_api(fd, location?.state?.data?._id);
//         if (res.data.status) {
//           navigate("/library-media");
//           notificationHandler({ type: "success", msg: res.data.message });
//         } else {
//           notificationHandler({ type: "success", msg: res.data.message });
//         }
//       } catch (error) {
//         notificationHandler({ type: "danger", msg: error.message });
//         console.log(error);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchallTagFunc();
//   }, []);

//   const fetchallTagFunc = async () => {
//     try {
//       let res = await get_all_tag_list_dropdown();
//       if (res.data.status) {
//         setallTag(res?.data?.data?.tags);
//       } else {
//         console.log("false Status!");
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   return (
//     <>
//       <div className="">
//         <Card className={s["admin_container"]}>
//           <div className={s["title"]} onClick={() => navigate(-1)}>
//             <BiArrowBack />
//             Back
//           </div>
//           <Grid
//             container
//             rowSpacing={1}
//             columnSpacing={{ xs: 1, sm: 2, md: 3 }}
//           >
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Title English</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="titleEnglish"
//                   value={titleEnglish}
//                   onChange={(e) => settitleEnglish(e.target.value)}
//                   placeholder="Title English"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Title Hindi</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="titleHindi"
//                   value={titleHindi}
//                   onChange={(e) => settitleHindi(e.target.value)}
//                   placeholder="Title Hindi"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Desc English</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="descEnglish"
//                   value={descEnglish}
//                   onChange={(e) => setdescEnglish(e.target.value)}
//                   placeholder="Desc English"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Desc Hindi</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="descHindi"
//                   value={descHindi}
//                   onChange={(e) => setdescHindi(e.target.value)}
//                   placeholder="Desc Hindi"
//                 />
//               </div>
//             </Grid>
//             {/* <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">URL</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="url"
//                   value={url}
//                   onChange={(e) => seturl(e.target.value)}
//                   placeholder="url"
//                 />
//               </div>
//             </Grid> */}
//               <Grid item xs={6}>
//                           <div className="form-group">
//                             <label htmlFor="videoFile">Upload MP3/MP4 File</label>
//                             <input
//                               type="file"
//                               id="videoFile"
//                               className="form-control"
//                               accept="video/mp4,audio/mp4,audio/mpeg"
//                               onChange={(e) => seturl(e.target.files[0])}
//                             />
//                           </div>
//                         </Grid>
//             {/* <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Tags</label>
//                 <select
//                   className="form-control"
//                   value={tags.join(" ,")}
//                   onChange={(e) => settags([...tags, e.target.value])}
//                 >
//                   <option default>Select Tag</option>
//                   {allTag?.map((row, id) => (
//                     <option value={row?.id}>{row?.name}</option>
//                   ))}
//                 </select>
//               </div>
//             </Grid> */}
//             {/* <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Tags</label>
//                 <MultipleSelect
//                   settags={settags} />
//               </div>
//             </Grid> */}
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Thumbnail</label>
//                 <input
//                   type="file"
//                   className="form-control"
//                   name="thumbnail"
//                   // value={thumbnail}
//                   onChange={(e) => setthumbnail(e.target.files[0])}
//                   placeholder="Thumbnail"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Lyrics (Hindi)</label>
//                 <RichTextEditor
//                   value={editor}
//                   className="employment_jobdescribee"
//                   onChange={onChange1}
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Lyrics (English)</label>
//                 <RichTextEditor
//                   value={editor2}
//                   className="employment_jobdescribee"
//                   onChange={onChange2}
//                 />
//               </div>
//             </Grid>
//           </Grid>

//           <div className={s["form-login-btn"]} onClick={() => create_user()}>
//             <Custombutton>Submit</Custombutton>
//           </div>
//         </Card>
//         \
//         <Loder loading={isLoading} />
//       </div>
//     </>
//   );
// };

// export default EditLibraryMedia;

import React, { useState, useEffect } from "react";
import s from "./language.module.css";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import Custombutton from "../../Common/Custombutton";
import { notificationHandler } from "../../utils/Notification";
import { Card, Grid } from "@mui/material";
import RichTextEditor from "react-rte-17";
import { get_all_tag_list_dropdown } from "../api/tag";
import {
  getLibraryMediaById_api,
  updateLanguage_api,
} from "../api/librarymedia";
import Loder from "../../Loder/Loder";

const EditLibraryMedia = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [titleEnglish, settitleEnglish] = useState("");
  const [titleHindi, settitleHindi] = useState("");
  const [descEnglish, setdescEnglish] = useState("");
  const [descHindi, setdescHindi] = useState("");
  const [thumbnail, setthumbnail] = useState("");

  const [editor, seteditor] = useState(RichTextEditor.createEmptyValue());
  const [editor2, seteditor2] = useState(RichTextEditor.createEmptyValue());

  const [tags, settags] = useState([]);
  const [allTag, setallTag] = useState([]);

  const [audioList, setAudioList] = useState([]);

  const [isLoading, setisLoading] = useState(false);

  // ---------------- FETCH DATA ----------------

  useEffect(() => {
    fetchLibraryMedia();
    fetchTags();
  }, []);

  const fetchLibraryMedia = async () => {
    setisLoading(true);
    try {
      let res = await getLibraryMediaById_api(
        location?.state?.data?._id
      );

      const libraryMedia = res?.data?.data?.libraryMedia;

      if (res.data.status) {
        settitleEnglish(libraryMedia?.titleEnglish);
        settitleHindi(libraryMedia?.titleHindi);
        setdescEnglish(libraryMedia?.descEnglish);
        setdescHindi(libraryMedia?.descHindi);
        setthumbnail(libraryMedia?.thumbnail?.url);

        // RTE
        seteditor(
          RichTextEditor.createValueFromString(
            libraryMedia?.lyrics?.hindi,
            "html"
          )
        );

        seteditor2(
          RichTextEditor.createValueFromString(
            libraryMedia?.lyrics?.english,
            "html"
          )
        );

        // 🔥 AUDIO PREFILL
        const formattedAudio = libraryMedia?.mediaFiles?.map((item) => ({
          _id: item._id,
          nameEnglish: item.nameEnglish,
          nameHindi: item.nameHindi,
          file: null,
          url: item.url,
        }));

        setAudioList(formattedAudio || []);
      }
    } catch (error) {
      console.log(error);
    }
    setisLoading(false);
  };

  const fetchTags = async () => {
    try {
      let res = await get_all_tag_list_dropdown();
      if (res.data.status) {
        setallTag(res?.data?.data?.tags);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------- AUDIO HANDLERS ----------------

  const handleAudioChange = (index, field, value) => {
    const updated = [...audioList];
    updated[index][field] = value;
    setAudioList(updated);
  };

  const addMoreAudio = () => {
    setAudioList([
      ...audioList,
      {
        tempId: "new" + (audioList.length + 1),
        nameEnglish: "",
        nameHindi: "",
        file: null,
      },
    ]);
  };

  const removeAudio = (index) => {
    const updated = audioList.filter((_, i) => i !== index);
    setAudioList(updated);
  };

  // ---------------- SUBMIT ----------------

  const handleSubmit = async () => {
    const fd = new FormData();

    fd.append("titleEnglish", titleEnglish);
    fd.append("titleHindi", titleHindi);
    fd.append("descEnglish", descEnglish);
    fd.append("descHindi", descHindi);
    fd.append("mediaType", "audio");

    fd.append(
      "lyrics",
      JSON.stringify({
        hindi: editor.toString("html"),
        english: editor2.toString("html"),
      })
    );

    fd.append("tags", tags);
    fd.append("thumbnail", thumbnail);

    // 🔥 AUDIO META
    const audioMeta = audioList.map((item) => {
      if (item._id) {
        return {
          _id: item._id,
          nameEnglish: item.nameEnglish,
          nameHindi: item.nameHindi,
        };
      } else {
        return {
          tempId: item.tempId,
          nameEnglish: item.nameEnglish,
          nameHindi: item.nameHindi,
        };
      }
    });

    fd.append("audioData", JSON.stringify(audioMeta));

    // 🔥 FILES
    audioList.forEach((item) => {
      if (item.file) {
        const key = item._id
          ? `file_${item._id}`
          : `file_${item.tempId}`;

        fd.append(key, item.file);
      }
    });

    try {
      let res = await updateLanguage_api(
        fd,
        location?.state?.data?._id
      );

      if (res.data.status) {
        navigate("/library-media");
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      notificationHandler({ type: "danger", msg: error.message });
    }
  };

  // ---------------- UI ----------------

  return (
    <Card className={s["admin_container"]}>
      <div className={s["title"]} onClick={() => navigate(-1)}>
        <BiArrowBack /> Back
      </div>

      <Grid container spacing={2}>
        {/* TITLE */}
        <Grid item xs={6}>
          <input
            className="form-control"
            value={titleEnglish}
            onChange={(e) => settitleEnglish(e.target.value)}
            placeholder="Title English"
          />
        </Grid>

        <Grid item xs={6}>
          <input
            className="form-control"
            value={titleHindi}
            onChange={(e) => settitleHindi(e.target.value)}
            placeholder="Title Hindi"
          />
        </Grid>

        {/* DESC */}
        <Grid item xs={6}>
          <input
            className="form-control"
            value={descEnglish}
            onChange={(e) => setdescEnglish(e.target.value)}
            placeholder="Desc English"
          />
        </Grid>

        <Grid item xs={6}>
          <input
            className="form-control"
            value={descHindi}
            onChange={(e) => setdescHindi(e.target.value)}
            placeholder="Desc Hindi"
          />
        </Grid>

        {/* THUMBNAIL */}
        <Grid item xs={6}>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setthumbnail(e.target.files[0])}
          />
        </Grid>

        {/* 🔥 AUDIO SECTION */}
        <Grid item xs={12}>
          <label>Audio List</label>

          {audioList.map((audio, index) => (
            <Card key={index} style={{ padding: 15, marginBottom: 15 }}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <input
                    className="form-control"
                    value={audio.nameEnglish}
                    onChange={(e) =>
                      handleAudioChange(index, "nameEnglish", e.target.value)
                    }
                    placeholder="Name English"
                  />
                </Grid>

                <Grid item xs={4}>
                  <input
                    className="form-control"
                    value={audio.nameHindi}
                    onChange={(e) =>
                      handleAudioChange(index, "nameHindi", e.target.value)
                    }
                    placeholder="Name Hindi"
                  />
                </Grid>

                <Grid item xs={3}>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      handleAudioChange(index, "file", e.target.files[0])
                    }
                  />
                  {audio.url && (
                    <small style={{ color: "green" }}>
                      Existing file present
                    </small>
                  )}
                </Grid>

                <Grid item xs={1}>
                  <button
                    className="btn btn-danger"
                    onClick={() => removeAudio(index)}
                  >
                    X
                  </button>
                </Grid>
              </Grid>
            </Card>
          ))}

          <button className="btn btn-primary" onClick={addMoreAudio}>
            + Add More
          </button>
        </Grid>

        {/* RTE */}
        <Grid item xs={12}>
          <RichTextEditor value={editor} onChange={seteditor} />
        </Grid>

        <Grid item xs={12}>
          <RichTextEditor value={editor2} onChange={seteditor2} />
        </Grid>
      </Grid>

      <div className={s["form-login-btn"]} onClick={handleSubmit}>
        <Custombutton>Update</Custombutton>
      </div>

      <Loder loading={isLoading} />
    </Card>
  );
};

export default EditLibraryMedia;